<template><div>
    <slot><div>Название поля</div></slot>
    <div :class="props.classinput">
        <multiselect class="MyMulti" @input="select" :value="vals" :options="props.list"  
            label="name"
            track-by="id"
            :placeholder="props.placeholder"
            :multiple="!props.onlyone"
            :searchable="true"
            :close-on-select="props.onlyone ? true : false"
            :clear-on-select="false"

            selectLabel="Выбрать"
            selectedLabel="Выбрано"
            deselectLabel="Убрать"
        >

            <template slot="option" slot-scope="{option,search,index}">
                <span class="opt">
                    <span class="c che">
                        <svg class="checkbox__check" width="24" height="24" viewBox="0 0 24 24">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <input type="checkbox" checked @click.prevent  @keydown.space.prevent />
                    </span>
                    <span class="c noche">
                        <svg class="checkbox__check" width="24" height="24" viewBox="0 0 24 24">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <input type="checkbox" @click.prevent  @keydown.space.prevent />
                    </span>
                    <span class="text">{{option.name}}</span>
                 </span>
            </template>
            <template slot="noResult" slot-scope="{search}">
                Не найдено
            </template>
            <template slot="selection" slot-scope="{remove, values, isOpen}">
                <div v-if="isOpen">
                    <template v-if="props.onlyone">
                        <span class="word" v-if="vals">
                            <button class="clear" @keypress.enter.prevent="remove(vals)" @mousedown.prevent="remove(vals)"  ><Delete /></button>
                            <span >{{vals.name}}</span>
                        </span>
                    </template>
                    <template v-else>
                        <span v-for="v in values" class="word" >
                            <button class="clear" @keypress.enter.prevent="remove(v)" @mousedown.prevent="remove(v)"  ><Delete /></button>
                            <span>{{v.name}}</span>
                        </span>
                    </template>
                </div>
                <div v-else>
                    {{optionText(values)}}
                </div>
            </template>

        </multiselect>
    </div>
</div></template>

<style lang="scss" src="./Multiselect.scss"></style>
<style lang="scss" src="./MyMulti.scss"></style>

<script setup>
import {ref, computed} from 'vue'
import multiselect from 'vue-multiselect'
import Delete from '@/comp/BookCabins/delete.svg.vue'

const props = defineProps({
  list: Array, 
  choosed: [String, Number], 
  placeholder: String,
  onlyone: {
    type: Boolean,
    default: false,
  },
  classinput: {
    type: String,
    default: '',
  },
})
const emits = defineEmits([ 'input' ])

const optionText = (all) => {
    let [first, ...other] = all
    let ret = []
    if (first) {
        ret.push(first.name)
    }
    if (other && other.length) {
        ret.push(`и еще ${other.length}`)
    }
    let str = ret.join(' ')
    return str
}

const select = (newval) => {
    let str
    if (Array.isArray(newval)) {
        str = newval.map( ({id})=> id ).join(',')
    } else {
        str = newval ? newval.id : ''
    }

    emits('input', str)
}

const vals = computed(()=>{
    let ids = props.choosed ? props.choosed.split(',') : [] // '' в []
    let ret = props.list.filter( ({id}) => ids.includes(id)  )
    if (props.onlyone) {
        ret = ret[0]
    }
    return ret
})



</script>
